import React, { useEffect, useState } from 'react';
import ProjectActivityForm from '../../components/ProjectActivityForm';
import ProjectActivityTable from '../../components/ProjectActivityTable';
import { Activity, ProjectActivity } from '../../types/ActivityTypes';
import {Project } from '../../types/projectTypes'
import { createUpdateProjectActivity, deleteprojectActivity, getActivities, getProjectActivities } from '../../api/activityApi';

interface ProjectActivityPageProps {
  project: Project;
  onReorder: (reorderedActivities: ProjectActivity[]) => void;
  onSaveClick: () => void;
  onCloseClick: () => void;
}

const ProjectActivityPage: React.FC<ProjectActivityPageProps> = ({onReorder, project, onCloseClick, onSaveClick }) => {
  const [projectActivities, setProjectActivities] = useState<ProjectActivity[]>([]);  
  const [activities, setActivities] = useState<Activity[]>([]);
  const [reorderedActivities, setReorderedActivities] = useState<ProjectActivity[]>([]);
  
  // Fetch initial project activities from the API
  useEffect(() => {
    // Fetch activities related to the project from API (mocking here)
    fetchProjectActivities();
    fetchActivities();
  }, []);

  const handleParentReorder = (parentReorderData: ProjectActivity[]) => {
    onReorder(parentReorderData)
  };

  const handleReorder = (reorderedData: ProjectActivity[]) => {
    setReorderedActivities(reorderedData);
    handleParentReorder(reorderedData)
  };

  const fetchActivities = async () => {
    try {
    const fetchedActivities = await getActivities(); 
    setActivities(fetchedActivities);
    }
    catch (error) {
        console.error('Error fetching data:', error);
      }
  };

  const fetchProjectActivities = async () => {
    try {
      if(project.id){
        const fetchedProjectActivities =await getProjectActivities(project.id);
        setProjectActivities(fetchedProjectActivities);
      }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
   
  };

  const addProjectActivity = async (newActivity: ProjectActivity) => {
    // Llamada a la API para agregar la actividad
   try{    
    if(projectActivities.length > 0){
      newActivity.order = projectActivities.length + 1;
    }else{
      newActivity.order = 1;
    }
    let resp = await createUpdateProjectActivity(newActivity);
    setProjectActivities([...projectActivities, { ...newActivity, id: resp.id }]);
   
   }catch (error) {
    console.error('Error fetching data:', error);}

  };

  const updateProjectActivity = async (updatedActivity: ProjectActivity) => {
    setProjectActivities(
      projectActivities.map((activity) =>
        activity.id === updatedActivity.id ? updatedActivity : activity
      )
    );
    await createUpdateProjectActivity(updatedActivity);
  };

  const deleteProjectActivity = async (id: number) => {
    let remainingActivities : ProjectActivity[] = [];
    await deleteprojectActivity(id);
    remainingActivities = projectActivities.filter((activity) => activity.id !== id);
    for(let i=0; i<remainingActivities.length; i++){
      remainingActivities[i].order = i+1;
    }
    handleReorder(remainingActivities);
    setProjectActivities(remainingActivities);
  };

  const handleSaveActivities = async (activitiesToSave: ProjectActivity[]) => {
    for (const activity of activitiesToSave) {
      await createUpdateProjectActivity(activity);
    }
    // Opcional: refrescar
    await fetchProjectActivities();
    // Notificamos al padre si lo requiere (orden actualizado)
    onReorder(activitiesToSave);
    };

  return (
    <div>
      <h1>Actividades del Proyecto: {project.name}</h1>
      <ProjectActivityForm onSubmit={addProjectActivity} activities={activities} project={project} />
      <ProjectActivityTable
        projectActivities={projectActivities || []}
        onUpdate={updateProjectActivity}
        onDelete={deleteProjectActivity}
        activities={activities}
        onReorder={handleReorder}
        onSave={handleSaveActivities}
        onCloseClick={onCloseClick}
        fetchLatestActivities={fetchProjectActivities}
        project={project}
      />
    </div>
  );
};

export default ProjectActivityPage;
